import 'uni-pages';
// @ts-ignore
wx.__webpack_require_UNI_MP_PLUGIN__ = __webpack_require__;import App from './App'
import store from '@/store'
import Vue from 'vue'
import uView from '@/uni_modules/uview-ui'
import Nav from '@/components/nav/index.vue'

Vue.use(uView)
Vue.config.productionTip = false
App.mpType = 'app'
let vuexStore = require('./store/$u.mixin.js');
Vue.mixin(vuexStore);
Vue.component('Nav',Nav);

const app = new Vue({store,
    ...App
})

require('./common/http.interceptor')(app)
app.$mount()